import { React, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import { endPoints } from "../../Constant/Environment";
import swal from 'sweetalert';
import Loader from "../Loader/index";
import { addItemApi } from "../../Utility/Api";
import { resetSchema } from "../Schemas";
import { useFormik } from "formik";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
const initialValues = {
    email: '',
};

export default function ForgetSenderPassword({ handleFirstModalOpen }) {
    const [isLoading, setIsLoadinig] = useState(false);
    const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
        useFormik({
            initialValues,
            validationSchema: resetSchema,
            onSubmit: async (values, action) => {
                const success = await submitApi(values);
                if (success) {
                    action.resetForm();
                }
            },
        });

    async function submitApi(formData) {
        // console.log(formData)
        try {
            const url = `${endPoints.api.RESET_PASSWORD}`;
            setIsLoadinig(true);

            const response = await addItemApi(url, formData);
            // console.log(response);
            if (response.status === 200) {
                setIsLoadinig(false);
                handleFirstModalOpen();
                swal('Success!', 'Password Sent Successfully on your email. Please check it out.', 'success');
                return true;
            } else {
                setIsLoadinig(false);
                swal('Failed!', response.message, 'error');
                return false;
            }
        } catch (error) {
            setIsLoadinig(false);
            swal('Failed!', error, 'error');
            return false;
        }

    }
    return (
        <Col md={10}>
            <Form onSubmit={handleSubmit}
                className="contact-form Reative contact-01" >
                {isLoading && <Loader spinner={true} visible={isLoading} className="LoaderForm" />}
                <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Control type="email" name="email" value={values.email} placeholder="Enter Email Here" onChange={handleChange} onBlur={handleBlur} />
                    {errors.email && touched.email ? (
                        <small className="text-danger">{errors.email}</small>
                    ) : null}
                </Form.Group>

                <small class="text-dark justify-content-end d-flex form-text"><span onClick={handleFirstModalOpen}>Login now</span></small>
                <div className="justify-content-center d-flex">

                    <Button
                        variant="primary"
                        type="submit"
                        className="log-btn log-01"
                    >
                        Reset
                    </Button>
                </div>
            </Form>
        </Col>
    )
}
